module.exports = __webpack_public_path__ + "img/di_16_RecGroup.7bac7057.png";